import Page from '@/features/dashboard/payments/pages/Summary'

export default Page
